import React from 'react';
import { Users, Calendar, HelpCircle } from 'lucide-react';

/**
 * Компонент для параметров консалтинга
 */
const ConsultingSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  consultingLevels
}) => {
  if (!formData.consultingRequired) {
    return (
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <label className="inline-flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              name="consultingRequired"
              checked={formData.consultingRequired}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2">Включить консалтинговые услуги</span>
          </label>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
          <Users className="w-5 h-5 mr-2 text-blue-500" />
          Консалтинговые услуги
        </h3>
        <label className="inline-flex items-center text-sm text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="consultingRequired"
            checked={formData.consultingRequired}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2">Включить в расчет</span>
        </label>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Уровень консалтинга */}
        <div>
          <label htmlFor="consultingLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Уровень консалтинга
          </label>
          <select
            id="consultingLevel"
            name="consultingLevel"
            value={formData.consultingLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.consultingLevel ? 'input-error' : ''}`}
          >
            {consultingLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.consultingLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.consultingLevel}
            </p>
          )}
        </div>

        {/* Продолжительность консалтинга */}
        <div>
          <label htmlFor="consultingDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-blue-500" />
            Продолжительность (мес.)
          </label>
          <input
            type="text"
            id="consultingDuration"
            name="consultingDuration"
            value={formData.consultingDuration}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.consultingDuration ? 'input-error' : ''}`}
            placeholder="Количество месяцев"
          />
          {errors.consultingDuration && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.consultingDuration}
            </p>
          )}
        </div>
      </div>

      {/* Описание выбранного уровня консалтинга */}
      {formData.consultingLevel && (
        <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
          <div className="flex items-start">
            <HelpCircle className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
                {consultingLevels.find(l => l.id === formData.consultingLevel)?.name || 'Выбранный уровень'}
              </h4>
              <p className="text-xs text-blue-600 dark:text-blue-400">
                {consultingLevels.find(l => l.id === formData.consultingLevel)?.description || 
                'Описание выбранного уровня консалтинга. Включает информацию о типе услуг и поддержке.'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsultingSection;